import { render, staticRenderFns } from "./ChangePricesCsv.vue?vue&type=template&id=6954a258&scoped=true&"
import script from "./ChangePricesCsv.vue?vue&type=script&lang=js&"
export * from "./ChangePricesCsv.vue?vue&type=script&lang=js&"
import style0 from "./ChangePricesCsv.vue?vue&type=style&index=0&id=6954a258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954a258",
  null
  
)

export default component.exports